import { type ReactNode, useId, useState } from 'react'
import * as Mtds from '@mattilsynet/design/react'
import { FunnelIcon, XIcon } from '@phosphor-icons/react'
import { ModalDialog } from '../modal-dialog/ModalDialog'

type FilterDrawerProps = {
  children: ReactNode
  isFiltering: boolean
  title: string
  applyLabel?: string
  isApplyLoading?: boolean
  showApply?: boolean
  filterCount?: number
  onOpen?: () => void
  onReset?: () => void
}

export const FilterDrawer = ({
  children,
  isFiltering,
  applyLabel,
  isApplyLoading = false,
  showApply = true,
  filterCount,
  title,
  onOpen,
  onReset
}: FilterDrawerProps) => {
  const id = useId()
  const [isOpen, setOpen] = useState(false)

  return (
    <>
      <Mtds.Button
        type='button'
        data-variant='secondary'
        onClick={() => {
          onOpen?.()
          setOpen(true)
        }}
      >
        <FunnelIcon />
        Filtre
        {isFiltering && <Mtds.Badge data-badge={filterCount ?? '!'} />}
      </Mtds.Button>
      <ModalDialog
        id={id}
        closedby='any'
        data-placement='right'
        open={isOpen}
        onClose={() => setOpen(false)}
      >
        <Mtds.Flex data-align='center' data-justify='space-between'>
          <Mtds.Flex data-align='center'>
            <Mtds.Heading>{title}</Mtds.Heading>
            {onReset && (
              <Mtds.Button
                type='button'
                data-variant='tertiary'
                disabled={!isFiltering}
                onClick={onReset}
              >
                Nullstill
              </Mtds.Button>
            )}
          </Mtds.Flex>
          <Mtds.Button
            command='close'
            commandfor={id}
            data-variant='tertiary'
            aria-label='Lukk'
          >
            <XIcon />
          </Mtds.Button>
        </Mtds.Flex>
        {children}
        {applyLabel && showApply && (
          <Mtds.Flex className='mt-8'>
            <Mtds.Button
              type='button'
              data-variant='primary'
              command='close'
              commandfor={id}
              className='w-full'
              aria-busy={isApplyLoading || undefined}
              disabled={isApplyLoading}
            >
              {applyLabel}
            </Mtds.Button>
          </Mtds.Flex>
        )}
      </ModalDialog>
    </>
  )
}
